import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RoleAccessControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	const [data, setData] = useState([]);
	// const [leavedetaildata, setLeaveDetailData] = useState([]);
	


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");
	//const handleChange = (e) => setCheckbox(e.target.checked);

    const [payslipdet, setPayslipDetail] = useState({
            // status: "",
            remarks: "",
			dept_status:"",

        })
	

        const handelInput = (event) => {
            event.preventDefault();
            const { name, value } = event.target;
            console.log(name, value)
            setPayslipDetail({ ...payslipdet, [name]: value });
        }


		const [loading, setLoading] = useState(false);
		const handleEditPayslipStatus = (e) => {

			e.preventDefault();
			setLoading(true);

			// console.log(payslipdet.status);
			// console.log(payslipdet.remarks);
			// console.log(payslipdet.payment_id);
			
	
			// alert(payslipdet.floor_status);
				
	
	
	
			axios.post(API_BASE_URL + '/dept_payslip_status', { status: payslipdet.floor_status,remarks:payslipdet.remarks, request_id: payslipdet.request_id}, {
				headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			}).then(response => {
	
				// console.log(response.data);
	
				var status = response.data.status;
	
				if (status == 200) {
					toast.success(response.data.message, {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
	
					});
	
					setTimeout(() => {
						return history.push("Dept-payslip");
					}, 3000);
	
				} else if (status == 401) {
					toast.error(response.data.message, {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
	
					});
				}
				else if (status == 400) {
					toast.error(response.data.message, {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
	
					});
				}
	
	
			}).catch(error => {
	
				toast.error(error.response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
	
	
				});
	
			})
			.finally(() => {
         setTimeout(() => {
        setLoading(false);
      }, 3500); // enable button again after request finishes
	   });
	
	




		}
	


	useEffect(() => {
		axios.get(API_BASE_URL + '/dept_payslip_detail/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

		    // .then(res1 =>console.log(res1.data.leave_detail))
			.then(res1 => setPayslipDetail(res1.data.dept_payslip_detail))
			.catch(err => console.log(err));
	}, [])




	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4 col-lg-4">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title">Payslip Request</h5>
                                    </div>
                                    <div className="card-body">
                                      
                                        <div className="table-responsive">
                                            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                                    <tbody>

														<tr>
                                                        <th>Name</th>
                                                        <td>{payslipdet.full_name}</td>
                                                        </tr>
                                                        <tr>
                                                        <th>Employee Id</th>
                                                        <td>{payslipdet.employee_id}</td>
                                                        </tr>
                                                        
                                                        <tr>
                                                        <th>Applied On</th>
                                                        <td>{payslipdet.applied_on}</td>
                                                        </tr>
                                                        
                                        
                                        
                                                    </tbody>
                                            </table>
                                        </div>



                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8">
                                <form className="card" onSubmit={handleEditPayslipStatus}>
                                    <div className="card-body">
                                        {/* <h3 className="card-title">Update Status</h3> */}
                                        <div className="row">
                                         
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <select className="form-control show-tick" name="floor_status" value={payslipdet.dept_status} onChange={handelInput}>
                                                    <option value=''>Select Status</option>
													<option value="1" >Pending</option>
                                                    <option value="2" >Approved</option>
                                                    <option value="3" >Rejected</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group mb-0">
                                                    <label className="form-label">Reason</label>
                                                    <textarea rows={5} className="form-control" id="textarea" name="remarks" value={payslipdet.remarks}  onChange={handelInput} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    
                      

                                    <div className="card-footer text-left">

									<input type="hidden" name="request_id" value={payslipdet.request_id} />

										{payslipdet.status==1 && (

											<button type="submit" className="btn btn-primary" disabled={loading}>{loading ? "Saving..." : "Save"}</button>

								 )}
                                        
                                    </div>

                                    {/* {leavedet.status==1 && (

                                   
                                    )} */}
                                </form>
                           
                            </div>




                        </div>
                    </div>

                    </div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleAccessControl);